export default {
    taskReadBegin(state) {
        state.loading = true;
    },

    taskReadSuccess(state, data) {
        state.loading = false;
        state.data = data;
    },

    taskReadErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    taskReadAllBegin(state) {
        state.loading = true
    },

    taskReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list;
    },

    taskAddBegin(state) {
        state.loading = true;
    },

    taskAddSuccess(state) {
        state.loading = false;
    },

    taskAddError(state, err) {
        state.loading = false;
        state.error = err;
    },

    taskUpdateBegin(state) {
        state.loading = true;
    },

    taskUpdateSuccess(state, data) {
        state.loading = false;
        // find state.data index and replace it with new data
        const index = state.data.findIndex(task => task.id === data.id);
        state.data[index] = data;
    },

    taskUpdateError(state, err) {
        state.loading = false;
        state.error = err;
    },

    taskReadAllError(state, err) {
        state.loading = false;
        state.error = err;
    },

    starUpdateBegin(state) {
        state.loading = true;
    },

    starUpdateSuccess(state, data) {
        state.loading = false;
        state.data = data;
    },

    starUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    completeUpdateBegin(state) {
        state.loading = true;
    },

    completeUpdateSuccess(state, data) {
        state.loading = false;
        state.data = data;
    },

    completeUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    }
};
